import { render, staticRenderFns } from "./DayDate.vue?vue&type=template&id=59c589b3&"
import script from "./DayDate.vue?vue&type=script&lang=js&"
export * from "./DayDate.vue?vue&type=script&lang=js&"
import style0 from "./DayDate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports